import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { loadableReady } from '@loadable/component';
import { BrowserRouter } from 'react-router-dom';
import { getInitialData } from '@app/shared/utils/initialData';
import { sentryHub } from '@app/shared/utils/sentry';
import pkg from '../package.json';
import Root from './root.component';

const initialData = getInitialData();
sentryHub.init({
  dsn: SENTRY_DSN,
  environment: initialData?.context?.environment || 'local',
});

const rootId = `application:${pkg.name}`;
loadableReady(() => {
  let domElement = document.getElementById(rootId);

  if (!document.body.contains(domElement)) {
    domElement = document.createElement('section');
    domElement.id = rootId;
    document.body.appendChild(domElement);
  }

  if (domElement.hasChildNodes()) {
    hydrateRoot(
      domElement,
      <BrowserRouter>
        <Root />
      </BrowserRouter>,
    );
  } else {
    const root = createRoot(domElement);
    root.render(Root);
  }
});
